import React from 'react';

const AttestationSalaire = ({
                                nomComplet,
                                cin = "",
                                cnss = "",
                                poste ,
                                salaire = "",
                                salaireLettre = "",
                                nomEntreprise = "GO&DEV DELIVERY CENTER",
                                adresseEntreprise = "Villa 4 Rue Arromane Secteur 9 Bloc G Hay riad Rabat",
                                capital = "200.000,00 DH",
                                lieu = "RABAT",
                                date = "",
                                signataire = "Mahdi EL JAOUHARI"
                            }) => {
    return (
        <div style={{ padding: '40px', fontFamily: 'Georgia, serif', lineHeight: '1.8', position: 'relative', minHeight: '100vh' }}>
            <div style={{ textAlign: 'center' }}>
                <h2 style={{ marginBottom: '0px' }}>{nomEntreprise}</h2>
                <div style={{ fontSize: '14px' }}>
                    <p>SOCIETE A RESPONSABILITE LIMITEE A ASSOCIE UNIQUE</p>
                    <p>CAPITAL DE {capital}</p>
                    <p>SIEGE SOCIAL: {adresseEntreprise}</p>
                </div>
                <hr />
                <h3 style={{ textDecoration: 'underline' }}>ATTESTATION DE SALAIRE</h3>
            </div>

            <p>
                Je soussigné, Monsieur <strong>{signataire}</strong>, Directeur technique de la société <br />
                <strong>{`«${nomEntreprise}»`}</strong>, Société à responsabilité limitée, sise au <strong>{adresseEntreprise}</strong>,<br />
                atteste par la présente que <strong>{nomComplet}</strong>, titulaire de la CIN n° <strong>{cin || "........"}</strong>,
                immatriculé à la CNSS sous le n° <strong>{cnss || "........"}</strong>, est employé dans notre société en qualité de <strong>{poste}</strong>.
            </p>

            <p>
                Il perçoit un salaire net mensuel de <strong>{salaire || "........"} DH</strong> (<strong>{salaireLettre || "........"} Dirhams</strong>).
            </p>

            <p>
                Cette attestation est délivrée pour servir et valoir ce que de droit.
            </p>

            <p style={{ textAlign: 'right', marginBottom: '100px' }}>
                Fait à {lieu}, le {date || "……………"}
            </p>



            <div style={{ fontSize: '12px', textAlign: 'center', marginTop: '260px' }}>
                SARL au capital de {capital} -
                CNSS: 1054596 -
                <strong>Identifiant Fiscal</strong>: 26159497 -
                TP: 25502215 -
                RC: 179995 –
                <strong>ICE</strong> : 002125743000033
            </div>
        </div>
    );
};

export default AttestationSalaire;
